import PlaylistPage from './PlaylistPage'

export default [{
	path: '/playlist/:id',
	component: PlaylistPage
}]


// WEBPACK FOOTER //
// ./src/pages/playlist/playlistRoutes.js